import cn from "classnames"
import React from "react"

interface LoadingProps {
  className?: string
}

const Loading: React.FC<LoadingProps> = ({ className }) => (
  <div
    className={cn(
      "loading-animation h-5 w-5 animate-spin rounded-full border-8 border-white border-r-primary",
      className
    )}
  />
)

export default Loading
